import bus from "@src/services/EventBus"
import {
  JOURNEY_COMPLETED_EVENT,
  type JourneyCompletedPayload,
} from "@src/services/eventBusContract"
import { trackEvent } from "@src/utils/trackEvent"
import { useEffect } from "react"
import { useAnalyticsSuppressed } from "./useAnalyticsSuppressed"

const FIRST_ACTION_MAP = {
  deposit: "first_deposit",
  swap: "first_swap",
  withdraw: "first_withdrawal",
} as const

const STORAGE_PREFIX = "defuse_"

export function useFirstActionLogger() {
  const suppressed = useAnalyticsSuppressed()

  useEffect(() => {
    if (!bus || suppressed) return

    const listener = (payload: JourneyCompletedPayload) => {
      try {
        if (!(payload.flow in FIRST_ACTION_MAP)) return
        const flow = payload.flow as keyof typeof FIRST_ACTION_MAP
        const firstEvent = FIRST_ACTION_MAP[flow]
        const storageKey = `${STORAGE_PREFIX}${firstEvent}`
        if (localStorage.getItem(storageKey)) return

        localStorage.setItem(storageKey, "1")
        trackEvent(firstEvent, {
          journey_id: payload.journey_id,
          ...(payload.transaction_id
            ? { transaction_id: payload.transaction_id }
            : {}),
        })
      } catch {
        // Analytics and unavailable storage must never affect product behavior.
      }
    }

    bus.on(JOURNEY_COMPLETED_EVENT, listener)
    return () => {
      bus.removeListener(JOURNEY_COMPLETED_EVENT, listener)
    }
  }, [suppressed])
}
